const JOB_STATUSES = new Set([
  'queued', 'capturing', 'ocr', 'translating', 'validating', 'ready', 'failed', 'cancelled'
]);

export function clamp01(value) {
  const number = Number(value);
  return Number.isFinite(number) ? Math.min(1, Math.max(0, number)) : 0;
}

function normalizePoint(point) {
  return [clamp01(point?.[0]), clamp01(point?.[1])];
}

export function normalizeRegion(region, index = 0) {
  const polygon = Array.isArray(region?.polygon) ? region.polygon.slice(0, 4).map(normalizePoint) : [];
  const bbox = Array.isArray(region?.bbox) && region.bbox.length === 4
    ? region.bbox.map(clamp01)
    : polygon.length
      ? [
          Math.min(...polygon.map(point => point[0])),
          Math.min(...polygon.map(point => point[1])),
          Math.max(...polygon.map(point => point[0])),
          Math.max(...polygon.map(point => point[1]))
        ]
      : [0, 0, 0, 0];

  return {
    id: String(region?.id || `region-${index + 1}`),
    text: String(region?.text || '').trim(),
    confidence: clamp01(region?.confidence),
    polygon,
    bbox,
    readingOrder: Number.isInteger(region?.readingOrder) ? region.readingOrder : index,
    role: String(region?.role || 'body'),
    script: String(region?.script || 'unknown'),
    detectedLanguage: String(region?.detectedLanguage || 'und'),
    candidates: Array.isArray(region?.candidates) ? region.candidates : [],
    translation: {
      text: String(region?.translation?.text || ''),
      compactText: String(region?.translation?.compactText || ''),
      warnings: Array.isArray(region?.translation?.warnings) ? region.translation.warnings : []
    }
  };
}

export function normalizeDocument(document) {
  if (!document || !Array.isArray(document.pages)) throw new TypeError('Document OCR invalide.');
  return {
    documentId: String(document.documentId || crypto.randomUUID()),
    source: {
      kind: String(document.source?.kind || 'file'),
      name: String(document.source?.name || 'Document'),
      url: document.source?.url ? String(document.source.url) : null
    },
    pages: document.pages.map((page, pageIndex) => ({
      pageNumber: Number(page.pageNumber) || pageIndex + 1,
      width: Math.max(1, Number(page.width) || 1),
      height: Math.max(1, Number(page.height) || 1),
      imageUrl: String(page.imageUrl || ''),
      regions: (page.regions || []).map(normalizeRegion).sort((a, b) => a.readingOrder - b.readingOrder)
    })),
    warnings: Array.isArray(document.warnings) ? document.warnings : [],
    provenance: document.provenance && typeof document.provenance === 'object' ? document.provenance : {}
  };
}

export function assertJob(job) {
  if (!job?.jobId || !JOB_STATUSES.has(job.status)) throw new TypeError('Réponse de tâche OCR invalide.');
  return job;
}
